// Per-school feature config for the Weekly Plan module, keyed by school app id (sid).
// Schools not listed here fall back to DEFAULT_CONFIG (legacy behaviour), so changes
// stay scoped to the requested school only.

const DEFAULT_CONFIG = {
  periodNumberLabel: false, // "No. of Periods" -> "Period Number"
  teacherActivityLabel: false, // "Important Notes" -> "Teacher's Activity"
  learningOutcomes: false, // show the extra "Learning Outcomes" field
  hideAccomplished: false, // hide the "Accomplished" radio + its reason field
  assignmentLabel: false, // "Home Work" -> "Assignment"
};

const WEEKLY_PLAN_CONFIG = {
  // icis
  "1374": {
    periodNumberLabel: true,
    teacherActivityLabel: true,
    learningOutcomes: true,
    hideAccomplished: true,
    assignmentLabel: true,
  },
};

export const getWeeklyPlanConfig = (sid) => ({
  ...DEFAULT_CONFIG,
  ...(WEEKLY_PLAN_CONFIG[String(sid)] || {}),
});
